import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import messageEnSeed from './seed-en.json';
import messageIdSeed from './seed-id.json';
import { AppState } from '../state/MyStateProvider';
import { APP_STATE_ACTION_TYPE_USER_LOCALE, APP_STATE_ACTION_TYPE_USE_SYS_LOCALE } from '../state/seed-states';
import { getSysLocale } from './intl-helpers';
import { seedDefaultLocale, seedSupportedLocales } from './seed-intl';

const MyIntlProvider = (props) => {
  const {
    children,
    intlDefaultLocale,
    intlSupportedLocales,
    intlMessageLocales,
    intlMessageSeedLocales,
    intlExtraMessageLocales,
  } = props;
  const { state } = React.useContext(AppState);
  const userLocale = state[APP_STATE_ACTION_TYPE_USER_LOCALE];
  const useSysLocale = state[APP_STATE_ACTION_TYPE_USE_SYS_LOCALE];
  const sysLocale = getSysLocale();

  let locale = intlDefaultLocale;
  if (useSysLocale) {
    if (intlSupportedLocales.includes(sysLocale)) {
      locale = sysLocale;
    } else {
      // console.warn(`Warning: User's preffered locale: '${sysLocale}' is not supported`);
      locale = intlDefaultLocale;
    }
  } else if (userLocale && intlSupportedLocales.includes(userLocale)) {
    locale = userLocale;
  }

  const mergedMessages = {};
  Object.entries(intlMessageLocales).map(([loc, val]) => {
    if (loc === 'en') {
      mergedMessages.en = { ...val, ...messageEnSeed };
    } else if (loc === 'id') {
      mergedMessages.id = { ...val, ...messageIdSeed };
    } else {
      mergedMessages[loc] = { ...val, ...intlMessageSeedLocales[loc] };
    }
    return null;
  });
  Object.entries(intlExtraMessageLocales).map(([loc, messages]) => {
    Object.entries(messages).map(([loc2, mes]) => {
      mergedMessages[loc] = {
        ...mes,
        ...mergedMessages[loc],
      };
      return null;
    });
    return null;
  });


  const messages = mergedMessages;

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      {children}
    </IntlProvider>
  );
};

MyIntlProvider.propTypes = {
  children: PropTypes.node.isRequired,
  intlDefaultLocale: PropTypes.string,
  intlSupportedLocales: PropTypes.arrayOf(PropTypes.string),
  intlMessageLocales: PropTypes.objectOf(PropTypes.objectOf(PropTypes.string)),
  intlMessageSeedLocales: PropTypes.objectOf(PropTypes.objectOf(PropTypes.string)),
  intlExtraMessageLocales: PropTypes.objectOf(
    PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
  ),
};

MyIntlProvider.defaultProps = {
  intlDefaultLocale: seedDefaultLocale,
  intlSupportedLocales: seedSupportedLocales,
  intlMessageLocales: {
    en: {},
    id: {},
  },
  intlMessageSeedLocales: {},
  intlExtraMessageLocales: {},
};

export default MyIntlProvider;
